import { CopyOutlined } from '@ant-design/icons';
import { App } from 'antd';
import { memo, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export const ConsumerUrl = memo(() => {
  const [isSuccess, setSuccess] = useState(false);
  const { message } = App.useApp();

  useEffect(
    () =>
      void (isSuccess && message.success('Consumer ID was successfully copied', () => setSuccess(false)), [isSuccess]),
  );

  return (
    <CopyToClipboard text={import.meta.env.VITE_AUTH_SERVICE_BASE_URL} onCopy={() => setSuccess(true)}>
      <span style={{ cursor: 'pointer' }}>
        {import.meta.env.VITE_AUTH_SERVICE_BASE_URL} <CopyOutlined />
      </span>
    </CopyToClipboard>
  );
});
